export default __webpack_public_path__ + "static/media/19.dcc370e6.png";